<div class="reports-list container">
  <h1 class="header">{{ 'Reports.Name' | translate }}</h1>

  <div class="content">
    <div #filters class="content-card filters">
      <div class="top">
        <div class="top__right">
          <div class="generate-report-button">
            @if(hasAccessToActiveEmployeesReport) {
              <button [visibleWithPermissions]="['GenerateActiveEmployeesReport']"
                [matTooltip]=" 'Reports.GenerateActiveEmployeesDescription' | translate"
                [disabled]="isGeneratingSingleReport"
                (click)="onGenerateActiveEmployeesReport(false)" mat-raised-button color="accent">
                {{ 'Reports.GenerateActiveEmployees' | translate }}
              </button>
            }
          </div>
          <div class="generate-report-button">
            @if(hasAccessToActiveEmployeesReport) {
              <button [visibleWithPermissions]="['GenerateAllEmployeesInstitutionReport']"
                [matTooltip]=" 'Reports.GenerateAllEmployeesInstitutionDescription' | translate"
                [disabled]="isGeneratingAllInstitutionReport"
                (click)="onGenerateActiveEmployeesReport(true)" mat-raised-button color="accent">
                {{ 'Reports.GenerateAllEmployeesInstitution' | translate }}
              </button>
            }
          </div>
          <div class="generate-report-button">
            @if(hasAccessToLimit540Usage) {
              <button [visibleWithPermissions]="['Generate540LimitUsageReport']"
                [matTooltip]=" 'Reports.Generate540LimitUsageDescription' | translate"
                (click)="onGenerateLimit540UsageReport()" mat-raised-button color="accent">
                Generuj raport wykorzystania limitu 18/36
              </button>
            }
          </div>
        </div>
      </div>
    </div>

    <div class="content-card">
      <div class="wrapper custom-table">
        <mat-table class="table" [dataSource]="dataSource.reports$ | async" matSort [matSortActive]="defaultSortColumn"
          [matSortDirection]="defaultSortDirection" matSortDisableClear multiTemplateDataRows
          (matSortChange)="onSortChange()">
          <ng-container matColumnDef="Name">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
              {{ 'Reports.ReportName' | translate }}
              <app-table-header-sort></app-table-header-sort>
            </mat-header-cell>
            <mat-cell *matCellDef="let element" [ngClass]="{'bold': element.IsNewest}"><span
            [matTooltip]="element.DisplayName">{{ element.DisplayName }}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="ReportStatusName">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
            {{ 'Reports.Status' | translate }}
            <app-table-header-sort></app-table-header-sort>
          </mat-header-cell>
          <mat-cell *matCellDef="let element"><span [matTooltip]="element.ReportStatusName">
            <div class="label" [class.label--green]="element.ReportStatusId === reportStatusEnum.Downloaded"
              [class.label--orange]="element.ReportStatusId === reportStatusEnum.Generated"
              [class.label--gray]="element.ReportStatusId === reportStatusEnum.GenerationInProgress">
              <span class="label__dot"></span>
              <span class="label__name">{{ element.ReportStatusName }}</span>
            </div>
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="GeneratedDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'Reports.GeneratedDate' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" [ngClass]="{'bold': element.IsNewest}"><span>{{ element.GeneratedDate |
        date: 'dd-MM-yyyy HH:mm' }}</span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="DownloadedDate">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
        {{ 'Reports.DownloadedDate' | translate }}
        <app-table-header-sort></app-table-header-sort>
      </mat-header-cell>
      <mat-cell *matCellDef="let element" [ngClass]="{'bold': element.IsNewest}"><span>{{ element.DownloadedDate |
      date: 'dd-MM-yyyy HH:mm' }}</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="Actions">
    <mat-header-cell *matHeaderCellDef>{{ 'Actions' | translate }}</mat-header-cell>
    <mat-cell *matCellDef="let element">
      @if (element.ReportStatusId === reportStatusEnum.Generated || element.ReportStatusId === reportStatusEnum.Downloaded) {
        <button
          mat-icon-button [matTooltip]="'Reports.Download' | translate"
          (click)="onDownloadReport(element.Id, element.GeneratedDate, element.ReportTypeId, element.AdditionalData)">
          <mat-icon>download</mat-icon>
        </button>
      }
      <button mat-icon-button [matTooltip]="'Reports.Delete' | translate" (click)="onDeleteReport(element.Id)">
        <mat-icon>delete</mat-icon>
      </button>
    </mat-cell>
  </ng-container>
  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
</mat-table>
<mat-paginator [length]="dataSource.count$ | async" [pageSize]="10" [pageSizeOptions]="[10, 15, 20]">
</mat-paginator>
</div>
</div>
</div>
</div>